/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ElementRef, ViewEncapsulation } from '@angular/core';
import { FILTER_PATTERN_OPTIONS, JOIN_FILTER_PATTERN_OPTIONS } from '../../config/constants';
import { CommonService } from 'app/shared/services/common.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
  },
  encapsulation: ViewEncapsulation.None
})

export class FiltersComponent implements OnInit, OnChanges {
  @Input() listOptions: any;
  @Input() reset: any;
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() remove: EventEmitter<any> = new EventEmitter();
  @Output() toggleExpandedViewState: EventEmitter<any> = new EventEmitter();
  public showOptions = false;
  public elementRef;
  public dropDownOptions: any = {
    header: '',
    options: [],
    selectedHeaderText: ''
  };
  public notificationOptions = {
    timeOut: 4000,
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: true,
    maxLength: 0,
    position: ["right", "top"]
  };
  public selectedItems: any = [];
  public paternOptions = FILTER_PATTERN_OPTIONS;
  public joinPatternOptions = JOIN_FILTER_PATTERN_OPTIONS;
  private globalDateFormatVar: any = localStorage.getItem('globalDateFormat');
  public customDatePickerProgramDownOptions: Partial<BsDatepickerConfig> = {
    dateInputFormat: (this.globalDateFormatVar) ? this.globalDateFormatVar.toUpperCase() : 'MMM DD, YYYY',
    adaptivePosition: false,
    showTodayButton: true,
    todayPosition: 'center',
    datesDisabled: [],
    datesEnabled: [],
  };
  public mlsSettings: IDropdownSettings = {
    allowSearchFilter: false,
    itemsShowLimit: 1,
    enableCheckAll: true,
    selectAllText: 'Select All',
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    unSelectAllText: 'UnSelect All',
  };

  constructor(element: ElementRef, private commonService: CommonService) {
    this.elementRef = element;
  }

  ngOnInit() {
    this.dropDownOptions = this.listOptions;
    this.showOptions = this.listOptions.show || false;
    this.getSelectedOptions();
  }

  ngOnChanges(changes: any) {
    if (changes.reset && changes.reset.currentValue === true) {
      this.getSelectedOptions();
    }
    if (changes.listOptions && changes.listOptions.currentValue) {
      this.showOptions = this.listOptions.show || false;
      /* Newly added logic for comp builder stup page */
      this.dropDownOptions = changes.listOptions.currentValue;
      this.getSelectedOptions();
    }
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public displayOptions() {
    //Checkbox filter type
    if (this.dropDownOptions.filterType == 1 || this.dropDownOptions.filterType == 4) {
      this.showOptions = !this.showOptions;
      const changeContent = {
        filterId: this.dropDownOptions.id,
        filterStateToBe: this.showOptions,
        filterName: this.dropDownOptions.name
      };
      this.toggleExpandedViewState.emit(changeContent);
    }
  }

  public onClick(event: any) {
    const clickedComponent = event.target;
    const clickedComponentClass = "click-class";
    const classList = [];
    classList.push(clickedComponent.classList.value.split(" "));
    const indexOfClick = classList[0].indexOf(clickedComponentClass);
    let inside = false;
    if (indexOfClick != -1) {
      inside = true;
    } else {
      inside = false;
    }
    if (!inside) {
      if (this.showOptions) {
        this.showOptions = !this.showOptions;
      }
    }
  }

  public evtStopPropagation(event: any) {
    event.stopPropagation();
  }

  public onSelectionChange(evtObj: any) {
    const tempSelObj: any = {};
    tempSelObj.id = this.listOptions.id;
    tempSelObj.name = this.listOptions.name;

    /*MLM-2148 */
    if (this.dropDownOptions.filterType == 5 || this.dropDownOptions.filterType == 7) {
      tempSelObj.pattern = this.dropDownOptions.pattern;
    }
    /*MLM-2148 */

    if (evtObj.target && evtObj.target.type == "radio") {
      // radio button value property
      if (this.dropDownOptions.options.length > 0) {
        this.dropDownOptions.cvalue = false;
        this.getSelectedOptions();
        tempSelObj.options = this.selectedItems;
        this.change.emit(JSON.parse(JSON.stringify(tempSelObj)));
      }
      else {
        tempSelObj.options = [{ "name": (this.dropDownOptions.value) ? 'Yes' : 'No' }];
        this.change.emit(JSON.parse(JSON.stringify(tempSelObj)));
      }
    } else if (evtObj.target && evtObj.target.type == "checkbox") {
      if (this.dropDownOptions.options.length > 0) {
        this.getSelectedOptions();
        tempSelObj.options = this.selectedItems;
        //tempSelObj.options = [{ name: this.dropDownOptions.value || false }];
        this.change.emit(JSON.parse(JSON.stringify(tempSelObj)));
      }
      else {
        tempSelObj.options = [{ "name": this.dropDownOptions.value || false }];
        this.change.emit(JSON.parse(JSON.stringify(tempSelObj)));
      }
    }
  }

  // public onMultiSelectionChange() {
  //   const tempSelObj: any = {};
  //   tempSelObj.id = this.listOptions.id;
  //   tempSelObj.name = this.listOptions.name;
  //   if (this.dropDownOptions.options.length > 0) {
  //     tempSelObj.options = this.dropDownOptions.selectedIds.id.map(r => {
  //       return {'name': r}
  //     });
  //     this.change.emit(JSON.parse(JSON.stringify(tempSelObj)));
  //   }
  // }

  public onMultiSelectionChange(event: any) {
    const tempSelObj: any = {};
    tempSelObj.id = this.listOptions.id;
    tempSelObj.name = this.listOptions.name;

    if (Array.isArray(this.dropDownOptions.options) && this.dropDownOptions.options.length > 0) {
      // Handle new direct binding (dropDownOptions.selectedIds = array of selected objects)
      if (Array.isArray(this.dropDownOptions.selectedIds)) {
        tempSelObj.options = this.dropDownOptions.selectedIds.map((r: any) => ({ name: r.name || r.id || r }));
      }
      // Fallback for old structure (dropDownOptions.selectedIds.id = array of IDs)
      else if (this.dropDownOptions.selectedIds?.id && Array.isArray(this.dropDownOptions.selectedIds.id)) {
        tempSelObj.options = this.dropDownOptions.selectedIds.id.map((r: any) => ({ name: r }));
      } else {
        tempSelObj.options = [];
      }

      this.change.emit(JSON.parse(JSON.stringify(tempSelObj)));
    }
  }


  public onCSelectionChange(evtObj: any) {
    const tempSelObj: any = {};
    tempSelObj.id = this.listOptions.id;
    tempSelObj.name = this.listOptions.name;
    if (evtObj.target.type == 'radio') {
      // radio button value property
      if (this.dropDownOptions.options.length > 0) {
        this.getSelectedOptions();
        tempSelObj.options = this.selectedItems;
        this.change.emit(JSON.parse(JSON.stringify(tempSelObj)));
      }
    }
  }

  public applyValidationChange(e: any){
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) || e.keyCode == 101) {
      e.preventDefault();
    }
  }

  public applySelectionChange() {
    const tempSelObj: any = {};
    tempSelObj.id = this.listOptions.id;
    tempSelObj.name = this.listOptions.name;

    if (this.dropDownOptions.filterType == 5 || this.dropDownOptions.filterType == 7) {
      tempSelObj.pattern = this.dropDownOptions.pattern;
    }
    if (this.dropDownOptions.toValue && this.dropDownOptions.filterType == 7) {
      tempSelObj.options = [];
      if (this.dropDownOptions.fromValue && this.dropDownOptions.pattern == '<->') {
        tempSelObj.options.push({ 'name': (this.dropDownOptions.fromValue) ? this.dropDownOptions.fromValue.formatted : '' });
      }
      tempSelObj.options.push({ 'name': (this.dropDownOptions.toValue) ? this.dropDownOptions.toValue.formatted : '' });
    }
    else if (this.dropDownOptions.value || ((this.dropDownOptions.filterType == 5) && this.dropDownOptions.value >= 0)) {
      tempSelObj.options = [{ 'name': isNaN(this.dropDownOptions.value) ? this.dropDownOptions.value.trim() : this.dropDownOptions.value }];
    } else {
      tempSelObj.options = [];
    }
    this.change.emit(JSON.parse(JSON.stringify(tempSelObj)));
  }

  public removeFilter(filter: any) {
    this.remove.emit(filter);
  }

  private getSelectedOptions() {
    this.selectedItems = [];
    if (this.dropDownOptions && this.dropDownOptions.options && this.dropDownOptions.options.length > 0 && this.dropDownOptions.value) {
      for (const list of this.dropDownOptions.options) {
        const listNameBoolean = list.name === 'true' ? true : list.name;
        if (listNameBoolean == this.dropDownOptions.value) {
          if (this.dropDownOptions.filterType == 4) {
            list.isChecked = listNameBoolean;
            if (this.dropDownOptions.cvalue !== undefined) {
              list.cvalue = this.dropDownOptions.cvalue;
            }
          }
          this.selectedItems.push(list);
        } else if (this.dropDownOptions.filterType == 4) {
          list.isChecked = '';
        }
      }
    }
    else if (this.dropDownOptions && this.dropDownOptions.options) {
      for (const list of this.dropDownOptions.options) {
        if (list.isChecked) {
          this.selectedItems.push(list);
          if (this.dropDownOptions.filterType == 4) {
            this.dropDownOptions.value = list.name;
          }
        }
      }
    }
    if (this.dropDownOptions.filterType == 7 && this.dropDownOptions.toValue && !this.dropDownOptions.toValue.date) {
      this.dropDownOptions.toValue = this.commonService.prepareBSDateObj(this.dropDownOptions.toValue);
      if (this.dropDownOptions.fromValue) {
        this.dropDownOptions.fromValue = this.commonService.prepareBSDateObj(this.dropDownOptions.fromValue);
      }
    }
    let selectedText = '';
    if (this.selectedItems) {
      if (this.selectedItems.length === 0) {
        selectedText = '';
      } else if (this.selectedItems.length === 1) {
        selectedText += this.selectedItems[0].name;
      } else if (this.selectedItems.length > 1) {
        selectedText += this.selectedItems[0].name + ' & ' + (this.selectedItems.length - 1) + ' more';
      }
    }
    if (selectedText == '') {
      this.dropDownOptions.selectedHeaderText = '-- Select --';
    } else {
      this.dropDownOptions.selectedHeaderText = selectedText;
    }

  }

  public clearFilter(cntrl: any) {
    cntrl.value = '';
    this.applySelectionChange();
  }

  public loadClient(evt: any, cntrl: any) {
    cntrl.value = evt?.clientId;
    this.applySelectionChange();
  }

}
